module.exports = {"511123100":"玉津镇","511123101":"孝姑镇","511123102":"石溪镇","511123103":"清溪镇","511123105":"罗城镇","511123106":"芭沟镇","511123107":"龙孔镇","511123108":"定文镇","511123112":"舞雩镇","511123113":"玉屏镇","511123114":"大兴镇","511123115":"九井镇","511123116":"铁炉镇","511123117":"寿保镇","511123118":"双溪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511123.json
// module id = 2464
// module chunks = 0